<template>
  <div class="message-alert" v-if="show">
    <span class="l">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10 12.373C9.5 12.373 9.0625 12.8105 9.0625 13.3105C9.0625 13.8105 9.5 14.248 10 14.248C10.5 14.248 10.9375 13.8105 10.9375 13.3105C10.9375 12.8105 10.5 12.373 10 12.373Z"
          fill="#FF5555"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10 10.9385C10.5 10.9385 10.9375 10.501 10.9375 10.001V6.00098C10.9375 5.50098 10.5 5.06348 10 5.06348C9.5 5.06348 9.0625 5.50098 9.0625 6.00098V10.001C9.0625 10.501 9.5 10.9385 10 10.9385Z"
          fill="#FF5555"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.0001 3.33341C6.31818 3.33341 3.33341 6.31818 3.33341 10.0001C3.33341 13.682 6.31818 16.6667 10.0001 16.6667C13.682 16.6667 16.6667 13.682 16.6667 10.0001C16.6667 6.31818 13.682 3.33341 10.0001 3.33341ZM1.66675 10.0001C1.66675 5.39771 5.39771 1.66675 10.0001 1.66675C14.6025 1.66675 18.3334 5.39771 18.3334 10.0001C18.3334 14.6025 14.6025 18.3334 10.0001 18.3334C5.39771 18.3334 1.66675 14.6025 1.66675 10.0001Z"
          fill="#FF5555"
        />
      </svg>
      <span class="info">
        您还有{{ count }}门课程没有预约，立即<span class="red-btn" @click="doBook">预约课程</span
        >吧~
      </span>
    </span>
    <span class="r" @click="handleKnow">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M3.28608 3.286C3.54638 3.02571 3.9681 3.02582 4.22847 3.286L7.99995 7.05748L11.7714 3.286C12.0316 3.02602 12.4535 3.02619 12.7138 3.286C12.9742 3.54635 12.9742 3.96901 12.7138 4.22936L8.94233 7.99987L12.7138 11.7714C12.9742 12.0317 12.9742 12.4534 12.7138 12.7137C12.4535 12.9741 12.0318 12.9741 11.7714 12.7137L7.99995 8.94225L4.22944 12.7147C3.9691 12.9751 3.54643 12.975 3.28608 12.7147C3.02573 12.4544 3.02573 12.0317 3.28608 11.7714L7.05757 7.99987L3.28608 4.22838C3.0259 3.96802 3.02579 3.5463 3.28608 3.286Z"
          fill="#54535C"
        />
      </svg>
    </span>
  </div>
</template>

<script>
export default {
  name: 'BookCourseAlert',
  props: {
    show: Boolean,
    count: Number,
  },
  methods: {
    handleKnow() {
      this.$emit('onClose');
    },
    doBook() {
      this.$emit('onBook');
    },
  },
};
</script>

<style lang="scss" scoped>
.message-alert {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 400;

  font-size: 14px;
  color: #1d1b20;
  background-color: #ffefef;
  border-radius: 8px;
  padding: 8px 16px;
  height: 32px;

  .info {
    margin-left: 8px;
    .red-btn {
      color: #ff2020;
      font-weight: 500;
      cursor: pointer;
      margin-left: 4px;
      margin-right: 4px;
    }
  }
  .l {
    display: inline-flex;
    align-items: center;
  }
  .r {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
  }
}
</style>
